
import ReviewResourceView from '@/mixins/ReviewResourceView';
import { mapGetters, mapState, mapActions } from 'vuex';
import PhotoThumbnailProductScore from './PhotoThumbnailProductScore';

const PRODUCT_SCORE_SECTION_OFFSET = 2;

export default {
  i18nComponentKey: 'WidgetProductReviewsPhotoThumbnail.components.PhotoThumbnail',
  name: 'PhotoThumbnail',
  components: { PhotoThumbnailProductScore },
  mixins: [ReviewResourceView],
  computed: {
    ...mapGetters('widget', ['device']),
    ...mapState('widget', ['isMobile']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('review', ['productMetaReviewsCount']),
    defaultResourceParams() {
      return { fields: 'product_meta_reviews_count' };
    },
    reviewLayoutProps() {
      return {
        circular: false,
        showSideArrow: !this.isMobile,
        minHeight: this.reviewMediaSize
      };
    },
    reviewMediaSize() {
      return this.isMobile ? 88 : 120;
    },
    reviewMediaStyle() {
      return {
        width: `${this.reviewMediaSize}px`
      };
    },
    productScoreStyle() {
      return {
        '--product-score-size': `${this.reviewMediaSize +
          PRODUCT_SCORE_SECTION_OFFSET}px`
      };
    }
  },
  created() {
    if (this.widget.show_product_score) this.fetchProductScoreSummary();
  },
  methods: {
    ...mapActions('productScoreSummary', ['fetchProductScoreSummary']),
    ...mapActions('widget', ['openReviewPopup']),
    onReady() {
      this.$emit('ready');

      if (
        this.$refs.carousel &&
        this.$refs.carousel.updateFlickingEdgePositions
      ) {
        this.$refs.carousel.updateFlickingEdgePositions();
      }
    }
  }
};
